export const baseUrl: string =
  process.env.REACT_APP_API_URL || 'http://localhost:3000'
export const isProd: boolean = process.env.NODE_ENV === 'production'

export const buildVersion: string = process.env.REACT_APP_BUILD_VERSION || ''

export const buildDate: Date | null = process.env.REACT_APP_BUILD_TIME
  ? new Date(parseInt(process.env.REACT_APP_BUILD_TIME) * 1000)
  : null

export const sentryDSN: string = process.env.REACT_APP_SENTRY_DSN || ''
